export default __webpack_public_path__ + "static/media/Silvopasture_Aerial_BEFORE1.08e25045.jpg";